(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8355,1674],{

/***/ 625530:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/shop",
      function () {
        return __webpack_require__(411089);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 411089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(755847);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331399);
/* harmony import */ var _containers_Shop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(578383);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(268037);








var ShopPage = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name).concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.address) === null || ref1 === void 0 ? void 0 : ref1.visibility) === 1 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.address) === null || ref2 === void 0 ? void 0 : ref2.city) ? ", ".concat((ref3 = storeInfo.address) === null || ref3 === void 0 ? void 0 : ref3.city) : "", " - Order Online"),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.logo_image,
        metaDescription: storeInfo && (0,_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_7__/* .getMetaDescription */ .w)(storeInfo),
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.store_info) === null || ref5 === void 0 ? void 0 : ref5.logo_image,
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Shop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,8388,1562,5843,6379,4814,7856,6576,9228,4429,8487,1033,1399,3978,2682,3973,526,2031,9875,7909,8557,1788,4640,6307,2265,5684,1988,9774,2888,179], function() { return __webpack_exec__(625530); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);